import styled from "styled-components";
import { BREAKPOINTS } from "../../../app/appConstants";

export const PageKYCStyled = styled.div`
    > div {
        width: 700px;
        @media (max-width: ${BREAKPOINTS.medium}px) {
            width: 100%;
        }
    }
`;
